import Vue from 'vue';
// import firebase from '@firebase/app';
import '@firebase/firestore';
import '@firebase/auth';
// import axios from 'axios';

import store from '../store';

export default function execute(axios) {
  axios.interceptors.request.use(
    async config => {
      // skipAuth 옵션이 true면 인증 건너뛰기
      if (!config.skipAuth) {
        let token = await store.dispatch('getValidToken');
        if(token){
          config.headers.Authorization = `Bearer ${token}`
        }
      }

      if (config.loading === undefined) {
        config.loading = true;
      }

      store.commit('setLoading', config.loading);

      return config;
    },
    function (err) {
      store.commit('setLoading', false);
      return Promise.reject(err);
    }
  );

  axios.interceptors.response.use(
    response => {
      store.commit('setLoading', false);
      return response;
    },
    function (err) {
      store.commit('setLoading', false);

      let message = typeof err.response !== 'undefined' ? err.response.data.message : err.message;
      console.warn('error', message);
      if (
        err.config &&
        Object.prototype.hasOwnProperty.call(err.config, 'errorHandle') &&
        err.config.errorHandle === false
      ) {
        return Promise.reject(err);
      }

      let bSnackbar = true;
      store.commit('setError', err);
      if (err.response) {
        // if (err.response.data === 'Unauthorized') {
        if ((store.getters.user || {}).email) {
          if (403 === err.response.status) {
            store.commit('setMsg', 'PERMISSION_DENIED');
            store.dispatch('logout');
          } else if (409 === err.response.status) {
            // 409 에러 분기 처리
            const errorCode = err.response?.data?.error?.code;
            
            if (errorCode === 'CONCURRENT_MODIFICATION_CONFLICT') {
              // optimistic locking 충돌 - 여기서 일괄 팝업 처리
              location.reload();
              
              store.commit('setMsg', '최신 수정된 내용이 있습니다. 최신 정보를 다시 불러오겠습니다.');
              store.commit('setShowSnackbar', true);
            } else {
              // 기존 다중 기기 접속 경고
              store.commit('setMsg', '현재 다른 인터넷 창에서 광고를 등록중입니다. 해당 창에서 계속 진행해주세요.');
              location.href = '/';
            }
          } else {
            store.commit('setMsg', err.response.data);
            console.log(err.response.data);
          }
        } else {
          bSnackbar = false;
        }
      } else if (err.message === 'Network Error') {
        store.commit('setMsg', '서버에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.');
      }
      if (!Vue._.isEmpty(store.getters.msg)) {
        store.commit('setShowSnackbar', bSnackbar);
      }
      return Promise.reject(err);
    }
  );
}
